<router-outlet></router-outlet>
<ng-container *ngIf="_errorMessage">
    <div style="padding: 2em; margin: 2em; border: 1px solid red">
        <b style="color: red">{{ _errorMessage }}</b
        >&nbsp;&nbsp;
        <a href="#" (click)="_logout($event)" class="button-like">Logout</a>
    </div>
</ng-container>
